// extracted by mini-css-extract-plugin
module.exports = {"item":"JoinSessionDialog_item__3aLhs","appbar":"JoinSessionDialog_appbar__2-FOu"};